<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header card-header-icon">
            <div class="card-icon crd-icon">
              <i class="material-icons">perm_identity</i>
            </div>
            <h4 class="card-title">Register</h4>
          </div>
          <div class="card-body">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <br />
              <div class="row mb-6 justify-content-center">
                <div class="col-md-12 text-center">
                  <!-- class="btn btn-dark btn-sm btn-step" -->
                  <a
                    [ngClass]="{
                    btn: true,
                    'btn-sm': true,
                    'btn-dark': true,
                    'btn-step': step !== 1,
                    'btn-step__selected': step === 1,
                  }"
                    (click)="changeStep(1)"
                  >
                    Profile
                  </a>
                  <a
                    [ngClass]="{
                      btn: true,
                      'btn-sm': true,
                      'btn-dark': true,
                      'btn-step': step !== 2,
                      'btn-step__selected': step === 2,
                    }"
                    (click)="changeStep(2)"
                  >
                    Compliance
                  </a>
                </div>
              </div>
              <br />

              <!-- Profile -->

              <div *ngIf="step == 1">
                <div class="row">
                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="firstname"
                        >Name</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="firstname"
                        formControlName="firstname"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('firstname')"
                      >
                        Name is required
                      </div>
                    </div>
                  </div>
                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="lastname"
                        >Last Name</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="lastname"
                        formControlName="lastname"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('lastname')"
                      >
                        Last name is required
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <!-- <div class="form-group">
                    <label class="bmd-label-floating" for="identification"
                      >Identification</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="identification"
                      formControlName="identification"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('identification')"
                    >
                      Identification is required
                    </div>
                  </div> -->
                    <div class="form-group">
                      <label class="bmd-label-floating" for="identification"
                        >Identification</label
                      >
                      <select
                        class="form-control select"
                        id="identification"
                        formControlName="identification"
                      >
                        <option value="" disabled>
                          Select a identification
                        </option>
                        <option
                          *ngFor="let item of identifications"
                          [value]="item"
                        >
                          {{ item }}
                        </option>
                      </select>
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('identification')"
                      >
                        Identification is required
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="rut"
                        >S.S / RUT</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="rut"
                        formControlName="rut"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('rut')"
                      >
                        RUT is required
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="username"
                        >Email</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="username"
                        formControlName="username"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('username')"
                      >
                        Email is required
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="title"
                        >Title</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="title"
                        formControlName="title"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('title')"
                      >
                        The title is required
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-5 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="indicative"
                        >Indicative</label
                      >
                      <select
                        class="form-control select"
                        id="indicative"
                        formControlName="indicative"
                      >
                        <option value="" disabled>Select</option>
                        <option *ngFor="let item of indicatives" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('indicative')"
                      >
                        Indicative is required
                      </div>
                    </div>
                  </div>
                  <div class="col-7 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="phone"
                        >Phone</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="phone"
                        formControlName="phone"
                        (input)="formatPhone($event)"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('phone')"
                      >
                        Phone is required
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="address"
                        >Address</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="address"
                        formControlName="address"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('address')"
                      >
                        Address is required
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="apt">Apt</label>
                      <input
                        type="text"
                        class="form-control"
                        id="apt"
                        formControlName="apt"
                      />
                    </div>
                  </div>
                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="city">City</label>
                      <input
                        type="text"
                        class="form-control"
                        id="city"
                        formControlName="city"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('city')"
                      >
                        City is required
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="state"
                        >State</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="state"
                        formControlName="state"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('state')"
                      >
                        State is required
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="country"
                        >Country</label
                      >
                      <select
                        class="form-control select"
                        id="country"
                        formControlName="country"
                      >
                        <option value="" disabled>Select a country</option>
                        <option *ngFor="let item of countries" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('country')"
                      >
                        Country is required
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="password"
                        >Password</label
                      >
                      <div class="d-flex">
                        <input
                          [type]="showPassword ? 'text' : 'password'"
                          class="form-control"
                          id="password"
                          formControlName="password"
                        />
                        <div class="input-group-append">
                          <span
                            class="input-group-text"
                            style="cursor: pointer"
                            (click)="togglePasswordVisibility()"
                          >
                            <i class="material-icons">{{
                              showPassword ? "visibility_off" : "visibility"
                            }}</i>
                          </span>
                        </div>
                      </div>
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('password')"
                      >
                        Password is required
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="confirmPassword"
                        >Confirm password</label
                      >
                      <div class="d-flex">
                        <input
                          [type]="showPasswordTwo ? 'text' : 'password'"
                          class="form-control"
                          id="confirmPassword"
                          formControlName="confirmPassword"
                        />
                        <div class="input-group-append">
                          <span
                            class="input-group-text"
                            style="cursor: pointer"
                            (click)="togglePasswordVisibilityTwo()"
                          >
                            <i class="material-icons">{{
                              showPasswordTwo ? "visibility_off" : "visibility"
                            }}</i>
                          </span>
                        </div>
                      </div>
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('confirmPassword')"
                      >
                        Confirm password is required
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      <!-- <label class="bmd-label-floating" for="img"
                      >Select image</label
                    > -->
                      <a
                        (click)="selectFile()"
                        [class.disabled]="upload"
                        [style.pointer-events]="upload ? 'none' : 'auto'"
                        [style.opacity]="upload ? '0.5' : '1'"
                        style="
                          cursor: pointer;
                          text-decoration: underline;
                          color: #007bff;
                        "
                      >
                        Select photo
                        <input
                          #fileInput
                          type="file"
                          (change)="captureFile($event)"
                          style="display: none"
                          accept="image/*"
                        />
                      </a>
                      <span *ngIf="upload"> (Uploaded) </span>
                      <button
                        *ngIf="upload"
                        type="button"
                        class="btn btn-dark btn-sm btn-update"
                        (click)="removeFile('img')"
                      >
                        X
                      </button>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <a
                        (click)="selectFileTwo()"
                        [class.disabled]="upload_two"
                        [style.pointer-events]="upload_two ? 'none' : 'auto'"
                        [style.opacity]="upload_two ? '0.5' : '1'"
                        style="
                          cursor: pointer;
                          text-decoration: underline;
                          color: #007bff;
                        "
                      >
                        Select identification
                        <input
                          #fileInputTwo
                          type="file"
                          (change)="captureFileTwo($event)"
                          style="display: none"
                          accept="image/*"
                        />
                      </a>
                      <span *ngIf="upload_two"> (Uploaded) </span>
                      <button
                        *ngIf="upload_two"
                        type="button"
                        class="btn btn-dark btn-sm btn-update"
                        (click)="removeFile('imgIdentification')"
                      >
                        X
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Compliance -->
              <div *ngIf="step == 2" formGroupName="compliance">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <a
                        (click)="selectFileThree('fileInputThree')"
                        *ngIf="!id"
                        [class.disabled]="uploadStatus.contract"
                        [style.pointer-events]="
                          uploadStatus.contract ? 'none' : 'auto'
                        "
                        [style.opacity]="uploadStatus.contract ? '0.5' : '1'"
                        style="
                          cursor: pointer;
                          text-decoration: underline;
                          color: #007bff;
                        "
                      >
                        Select contract
                        <input
                          #fileInputThree
                          type="file"
                          (change)="
                            captureFileThree(
                              $event,
                              'contract',
                              'contract',
                              'compliance'
                            )
                          "
                          style="display: none"
                          accept="application/pdf"
                        />
                      </a>
                      <span *ngIf="uploadStatus.contract"> (Uploaded) </span>
                      <button
                        *ngIf="uploadStatus.contract"
                        type="button"
                        class="btn btn-dark btn-sm btn-update"
                        (click)="
                          removeFileTwo('contract', 'contract', 'compliance')
                        "
                      >
                        X
                      </button>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <a
                        (click)="selectFileThree('fileInputFour')"
                        *ngIf="!id"
                        [class.disabled]="uploadStatus.nda"
                        [style.pointer-events]="
                          uploadStatus.nda ? 'none' : 'auto'
                        "
                        [style.opacity]="uploadStatus.nda ? '0.5' : '1'"
                        style="
                          cursor: pointer;
                          text-decoration: underline;
                          color: #007bff;
                        "
                      >
                        Select NDA
                        <input
                          #fileInputFour
                          type="file"
                          (change)="
                            captureFileThree($event, 'nda', 'nda', 'compliance')
                          "
                          style="display: none"
                          accept="application/pdf"
                        />
                      </a>
                      <span *ngIf="uploadStatus.nda"> (Uploaded) </span>
                      <button
                        *ngIf="uploadStatus.nda"
                        type="button"
                        class="btn btn-dark btn-sm btn-update"
                        (click)="removeFileTwo('nda', 'nda', 'compliance')"
                      >
                        X
                      </button>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <a
                        (click)="selectFileThree('fileInputFive')"
                        [class.disabled]="uploadStatus.licensesMedical"
                        [style.pointer-events]="
                          uploadStatus.licensesMedical ? 'none' : 'auto'
                        "
                        [style.opacity]="
                          uploadStatus.licensesMedical ? '0.5' : '1'
                        "
                        style="
                          cursor: pointer;
                          text-decoration: underline;
                          color: #007bff;
                        "
                      >
                        Select sick leave
                        <input
                          #fileInputFive
                          type="file"
                          (change)="
                            captureFileThree(
                              $event,
                              'licensesMedical',
                              'licenses',
                              'compliance'
                            )
                          "
                          style="display: none"
                          accept="application/pdf"
                        />
                      </a>
                      <span *ngIf="uploadStatus.licensesMedical">
                        (Uploaded)
                      </span>
                      <button
                        *ngIf="uploadStatus.licensesMedical"
                        type="button"
                        class="btn btn-dark btn-sm btn-update"
                        (click)="
                          removeFileTwo(
                            'licensesMedical',
                            'licenses',
                            'compliance'
                          )
                        "
                      >
                        X
                      </button>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <a
                        (click)="selectFileThree('fileInputSix')"
                        [class.disabled]="uploadStatus.insurance"
                        [style.pointer-events]="
                          uploadStatus.insurance ? 'none' : 'auto'
                        "
                        [style.opacity]="uploadStatus.insurance ? '0.5' : '1'"
                        style="
                          cursor: pointer;
                          text-decoration: underline;
                          color: #007bff;
                        "
                      >
                        Select medical insurance
                        <input
                          #fileInputSix
                          type="file"
                          (change)="
                            captureFileThree(
                              $event,
                              'insurance',
                              'insurance',
                              'compliance'
                            )
                          "
                          style="display: none"
                          accept="application/pdf"
                        />
                      </a>
                      <span *ngIf="uploadStatus.insurance"> (Uploaded) </span>
                      <button
                        *ngIf="uploadStatus.insurance"
                        type="button"
                        class="btn btn-dark btn-sm btn-update"
                        (click)="
                          removeFileTwo('insurance', 'insurance', 'compliance')
                        "
                      >
                        X
                      </button>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="startContract"
                        >Contract signing date</label
                      >
                      <input
                        type="date"
                        class="form-control"
                        id="startContract"
                        formControlName="startContract"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="endContract"
                        >Expiration date</label
                      >
                      <input
                        type="date"
                        class="form-control"
                        id="endContract"
                        formControlName="endContract"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="verifiedBy"
                        >Verified by</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="verifiedBy"
                        formControlName="verifiedBy"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="background"
                        >Background</label
                      >
                      <select
                        class="form-control"
                        id="background"
                        formControlName="background"
                      >
                        <option value="" disabled>Select a background</option>
                        <option *ngFor="let item of backgrounds" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('background')"
                      >
                        The background is required
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="legalStatus"
                        >Legal status</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="legalStatus"
                        formControlName="legalStatus"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <div class="row text-center">
                <div class="col-12">
                  <button
                    type="submit"
                    class="btn btn-dark pull-right btn-update"
                    [disabled]="form.invalid || isLoading"
                  >
                    Register
                  </button>
                </div>
              </div>
              <div class="clearfix"></div>
            </form>
            <!--  <button (click)="pru()" >prueba</button> -->
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card card-profile">
          <div class="card-body">
            <br />
            <img
              [src]="getProfileImgUrl('img')"
              class="imgs"
              alt="Driver Image"
            />
          </div>
          <hr />
          <div class="card-body">
            <br />
            <img
              [src]="getProfileImgUrl('imgIdentification')"
              class="img__identification"
              alt="Identification Image"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
